import { useState, useCallback } from 'react';

export const useErrorHandler = (initialErrors = {}) => {
    const [errors, setErrors] = useState({
        local: initialErrors,  // Form validation errors, etc.
        api: {                 // API-related errors
            isError: false,
            message: ''
        }
    });

    const setLocalError = useCallback((field, message) => {
        setErrors(prev => ({
            ...prev,
            local: {
                ...prev.local,
                [field]: message
            }
        }));
    }, []);

    const setApiError = useCallback((message) => {
        setErrors(prev => ({
            ...prev,
            api: {
                isError: Boolean(message),
                message: message || ''
            }
        }));
    }, []);

    const clearLocalError = useCallback((field) => {
        setErrors(prev => ({
            ...prev,
            local: {
                ...prev.local,
                [field]: ''
            }
        }));
    }, []);

    const clearApiError = useCallback(() => {
        setErrors(prev => ({
            ...prev,
            api: {
                isError: false,
                message: ''
            }
        }));
    }, []);

    const clearAllErrors = useCallback(() => {
        setErrors({
            local: {},
            api: {
                isError: false,
                message: ''
            }
        });
    }, []);

    const hasLocalErrors = Object.values(errors.local).some(error => Boolean(error));
    const hasApiError = errors.api.isError;
    const hasAnyError = hasLocalErrors || hasApiError;

    return {
        errors,
        setLocalError,
        setApiError,
        clearLocalError,
        clearApiError,
        clearAllErrors,
        hasLocalErrors,
        hasApiError,
        hasAnyError
    };
};